@if (errorMessage) {
  <div class="outline error cd-text-md">
    <small>{{ errorMessage }}</small>
  </div>
}

<div class="w-full flex flex-row items-center gap-4">
  @if (allowFiles) {
    <button class="btn btn-primary flex flex-row gap-2 items-center min-w-[3rem]"
            type="button"
            (click)="fileInput.click()"
            style="border-radius: 0.5rem;padding: 0.5rem 1rem">
      <img alt="Icon" class="filter-neutral-100 h-4" src="/assets/icons/feather/upload.svg">
      <span class="hidden lg:block cd-text-md truncate capitalize">Adjuntar archivos</span>
    </button>
  }

  @if (allowAudio) {
    <button class="btn btn-primary-soft flex flex-row gap-2 items-center min-w-[3rem]"
            type="button"
            (click)="audioInput.click()"
            style="border-radius: 0.5rem;padding: 0.5rem 1rem">
      <img alt="Icon" class="filter-primary-600 h-4" src="/assets/icons/feather/mic.svg">
      <span class="hidden lg:block cd-text-md truncate capitalize">Agregar una nota de audio</span>
    </button>
  }
</div>

<input #fileInput (change)="handleAttachFiles($event)" class="hidden" multiple type="file"/>
<input #audioInput (change)="handleAudioFile($event)" class="hidden" type="file" accept="audio/*"/>

<div class="flex flex-col gap-2 w-full">
  <div class="flex flex-row justify-between border-b-1 pb-2">
    <span>Archivos adjuntos</span>
  </div>

  <div class="grid grid-cols-none lg:grid-cols-2 gap-2">
    @for (file of attachedFiles; track file.name) {
      <core-file-widget
        [fileName]="file.name"
        [fileSize]="(file.size / 1024).toFixed(2) + ' KB'"
        (remove)="removeAttachment($index)"
        class="border border-neutral-300"/>
    }
    @if (!attachedFiles.length) {
      <span class="cd-text-b3 text-neutral-500">No hay archivos adjuntos.</span>
    }
  </div>
</div>

@if (audioFile) {
  <div class="flex flex-row items-center gap-3 w-full border border-neutral-300 rounded-lg px-3 py-2 bg-neutral">
    <span class="cd-text-b3">{{ audioFile.name }}</span>
    <button class="btn btn-neutral-text !px-1 !py-1 ml-auto" type="button" (click)="removeAudio()">
      <img alt="Icon" class="filter-neutral-800 h-4" src="/assets/icons/feather/x.svg">
    </button>
  </div>
}
